/* eslint @typescript-eslint/no-explicit-any: 0 */
import { identity } from "ramda";
import { curryN } from "ramda";
import { mapObj } from "./mapObj.mjs";
export default curryN(2, (f, x) => mapObj(identity, f, x));
//# sourceMappingURL=mapVals.mjs.map